import type { ComponentSpec, QueryResponseSpec, TableComponentSpec, WidgetResponseSpec } from "../Processing/types";

const MOCK_PLAYERS = ["Player A", "Player B", "Player C", "Player D", "Player E"];

function seededRandom(seed: number): () => number {
  let s = seed;
  return () => {
    s = (s * 16807) % 2147483647;
    return (s - 1) / 2147483646;
  };
}

/**
 * Generate a mock WidgetResponseSpec whose query_ids match the table spec's
 * series[].queryId values.
 */
export function mockTableResponseFromSpec(
  spec: TableComponentSpec,
  widgetId: string,
): WidgetResponseSpec {
  let seedBase = 0;
  for (let i = 0; i < widgetId.length; i++) seedBase += widgetId.charCodeAt(i);

  return {
    widget_id: widgetId,
    series: spec.series.map((s, i) => {
      const rng = seededRandom(seedBase + i * 7919);
      const base = 65 + rng() * 20;
      const variance = 10;
      const data = MOCK_PLAYERS.map((player) => ({
        value: Math.round(Math.min(100, Math.max(50, base + (rng() - 0.5) * 2 * variance)) * 10) / 10,
        category: player,
      }));
      return {
        query_id: s.queryId,
        name: s.displayName.toUpperCase() || `COLUMN ${i + 1}`,
        data,
      } satisfies QueryResponseSpec;
    }),
  };
}

export function mockTableSpec(): ComponentSpec {
  return {
    type: "table",
    display: { title: "Player Summary" },
    series: [
      { queryId: "q-dist", displayName: "Distance (km)", metricIdentifierType: "metric", metricAgg: "sum" },
      { queryId: "q-sprints", displayName: "Sprints", metricIdentifierType: "metric", metricAgg: "sum" },
      { queryId: "q-load", displayName: "Load (AU)", metricIdentifierType: "metric", metricAgg: "avg" },
    ],
    mutations: { showAverageRow: true },
  };
}

export function mockTableResponse(widgetId: string): WidgetResponseSpec {
  return {
    widget_id: widgetId,
    series: [
      {
        query_id: "q-dist",
        name: "DISTANCE SUM",
        data: [
          { value: 4.2, category: "Player A" },
          { value: 3.8, category: "Player B" },
          { value: 5.1, category: "Player C" },
          { value: 3.1, category: "Player D" },
          { value: 4.5, category: "Player E" },
        ],
      },
      {
        query_id: "q-sprints",
        name: "SPRINTS SUM",
        data: [
          { value: 18, category: "Player A" },
          { value: 22, category: "Player B" },
          { value: 15, category: "Player C" },
          { value: 28, category: "Player D" },
          { value: 20, category: "Player E" },
        ],
      },
      {
        query_id: "q-load",
        name: "LOAD AVG",
        data: [
          { value: 142, category: "Player A" },
          { value: 138, category: "Player B" },
          { value: 165, category: "Player C" },
          { value: 118, category: "Player D" },
          { value: 152, category: "Player E" },
        ],
      },
    ],
  };
}
